<template>
  <!-- 活动管理 -->
  <div>
    <div class="activityManage" v-if="createStep == 1">
      <!-- 头部表单查询 -->
      <input-form
        ref="inputForm"
        :inputData="inputData"
        :pageName="pageName"
        @toParentVal="searchForm"
        v-if="actManag == false"
      ></input-form>
      <input-form
        ref="inputForm"
        :inputData="inputData2"
        :pageName="pageName"
        @toParentVal="searchForm"
        v-else
      ></input-form>

      <!-- 表格内容 -->
      <el-table
        :data="activityList"
        v-loading="talbeLoading"
        style="width: 100%; margin-top: 20px"
        ref="table"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
        <el-table-column label="活动名称" width="280">
          <template slot-scope="scope">
            <div class="activityName">
              <el-popover placement="top-start" width="400" trigger="hover">
                <p style="margin: 20px">
                  请用手机京东扫描下面二维码查看您店铺的活动详情
                </p>
                <!-- <img src="" alt="活动二维码" style="margin-left: 60px" /> -->
                <div
                  class="qrcode"
                  :id="'qrcode' + scope.row.id"
                  :ref="'qrcode' + scope.row.id"
                  style="margin-left: 80px"
                ></div>
                <div>
                  <p style="margin: 20px">
                    链接地址：(手机京东店铺中活动详情链接地址)
                  </p>
                  <el-input
                    readonly
                    v-model="scope.row.idUrl"
                    style="margin: 0 20px; width: 220px"
                  ></el-input
                  ><el-button
                    type="primary"
                    v-clipboard:copy="scope.row.idUrl"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    >复制</el-button
                  >
                </div>
                <img
                  src="../../assets/images/integralCenter/list_code.svg"
                  alt="活动二维码"
                  class="code"
                  slot="reference"
                />
              </el-popover>
              <span>{{ scope.row.activityName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="活动类型">
          <template slot-scope="scope">
            <span v-if="scope.row.activityType == 1"> 日历签到 </span>
            <span v-if="scope.row.activityType == 2"> 浏览礼品有礼 </span>
            <span v-if="scope.row.activityType == 3"> 每日抢好礼 </span>
            <span v-if="scope.row.activityType == 4"> 关注店铺有礼 </span>
            <span v-if="scope.row.activityType == 5"> 邀请开卡 </span>
            <span v-if="scope.row.activityType == 6"> 邀请关注店铺 </span>
            <span v-if="scope.row.activityType == 7"> 完善信息有礼 </span>
            <span v-if="scope.row.activityType == 8"> 大转盘抽奖 </span>
          </template>
        </el-table-column>

        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <div class="activityTime">
              <span>起: {{ scope.row.startTime }}</span>
              <span>止: {{ scope.row.endTime }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="最后修改时间" prop="updateTime">
        </el-table-column>
        <el-table-column label="活动状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1"> <i class="y1"></i>未开始 </span>
            <span v-if="scope.row.status == 2"> <i class="y2"></i>进行中 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已结束 </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <div class="editList">
              <span
                v-if="scope.row.status == 1 || scope.row.status == 2"
                @click="modify(scope.row.activityType, scope.row)"
                v-zoom="{ from: pageName, name: '修改' }"
                class="edit"
                >修改</span
              >
              <span v-if="scope.row.status == 3">-</span>
              <span
                v-if="scope.row.status == 2"
                @click="endenActivity(scope.row.id)"
                v-zoom="{ from: pageName, name: '结束' }"
                class="end"
                >结束</span
              >
              <span v-if="scope.row.status == 1 || scope.row.status == 3"
                >-</span
              >
              <span @click="statisData(scope.row)" class="count">数据统计</span>
              <span
                v-zoom="{ from: pageName, name: '删除' }"
                @click="deleteActivity(scope.row)"
                class="delete"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="recordData.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="recordData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        class="pagination"
      >
      </el-pagination>
    </div>
    <!-- 创建活动步骤 -->
    <points-task-activity
      ref="createSte"
      v-if="createStep == 2"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
    ></points-task-activity>

    <!-- 创建活动步骤 -->
    <create-activity-step
      v-if="createStep == 4"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityDataTwo"
      :stepNum="stepNum"
      :ids="ids"
    ></create-activity-step>

    <statistics
      v-if="createStep == 3"
      @returnStep="returnStep"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics>
    <!-- v3.4邀请开卡 -->
    <create-invite-step
      ref="createSte"
      v-if="createStep == 5"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
    ></create-invite-step>

    <!-- 结束活动弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >是否结束活动？</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisibleTwo"
      width="400px"
      :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >是否删除活动？</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../components/inputForm";
import pointsTaskActivity from "./points_task_activity";
import createInviteStep from "./points_task_Invite";
import createActivityStep from "./create_activity_step";
import statistics from "./activity_data_statistics";
import { queryActivity, endEvent, deleteEvent } from "@/api/activityController";
import {
  searchfocusStores,
  editfollow,
  editInformation,
} from "@/api/integralCenter/integralTask";
import {
  getbigTurn,
  prefixurl,
} from "@/api/paradiseAndTaskCommonController.js";
export default {
  props: {
    actManag: {
      type: Boolean,
      defaults: false,
    },
  },
  components: {
    inputForm,
    pointsTaskActivity,
    createActivityStep,
    createInviteStep,
    statistics,
  },
  data() {
    return {
      pageName: "忠诚度管理-积分-活动管理",
      talbeLoading: false,
      qrcode: null,
      outerVisible: false,
      outerVisibleTwo: false,
      valueRow: {},
      createVal: 0,
      activityDataTwo: {
        telImg: require("../../assets/images/integralCenter/night_m.png"),
        telCode: require("../../assets/images/integralCenter/code.png"),
      },
      activityData: {},
      createStep: 1,
      activityList: [],
      // 头部表单配置项
      inputData: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },
        {
          name: "活动类型:",
          val: "activityType",
          placeholder: "请输入活动名称",
          selectArr: [
            { label: "全部", id: null },
            { label: "日历签到", id: 1 },
            // { label: "浏览商品有礼", id: 2 },
            { label: "每日抢好礼", id: 3 },
            { label: "关注店铺有礼", id: 4 },
            { label: "邀请开卡", id: 5 },
            { label: "邀请关注店铺", id: 6 },
            { label: "完善信息有礼", id: 7 },
            // { label: "大转盘抽奖", id: 8 },
          ],
        },
        {
          name: "活动时间:",
          myDate: true,
          noInitValue: true, // 不用给初始化值
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      inputData2: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },
      
        {
          name: "活动时间:",
          noInitValue: true,
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
      },
      rowData: {},
      ids: "",
      ids1: "",
      activityUrl: "",
      venderId: "",
      aaa: "",
      status: 1,
       mytimestart: "",
      mytimeend: "",
      opentime:true,
    };
  },

  mounted() {
    // this.time();
    this.prefixQue();
  },

  methods: {
    //时间拼装
     time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = `${this.getDateStr(-30)} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          this.$store.state.venderId = res.data.venderId;
          console.log(this.recordData);
          // this.queryList();
          this.$refs.inputForm.formSearch();
          
        })
        .catch((res) => {});
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
            this.outerVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    returnStep() {
      this.createStep = 1;
      this.recordData.current = 1;
      this.recordData.size = 10;
      this.prefixQue();
      // console.log(this.recordData,99988);
    },
    createActivity(type) {
      if (type==5) {
        this.createStep = 5;
        this.activityData = {
          id: 4,
          name: "邀请开卡",
          telImg: require("../../assets/images/integralCenter/kk.jpg"),
          telCode: this.idUrl5,
        };
        return 
      }
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            id: 1,
            name: "日历签到",
            telImg: require("../../assets/images/integralCenter/qdq.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 3:
          this.activityData = {
            id: 2,
            name: "每日抢好礼",
            telImg: require("../../assets/images/integralCenter/mrq.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 4:
          this.activityData = {
            id: 3,
            name: "关注店铺有礼",
            telImg: require("../../assets/images/integralCenter/gzdp.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡",
            telImg: require("../../assets/images/integralCenter/kk.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 6:
          this.activityData = {
            id: 5,
            name: "邀请关注店铺",
            telImg: require("../../assets/images/integralCenter/yqgz.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 7:
          this.activityData = {
            id: 6,
            name: "完善信息有礼",
            telImg: require("../../assets/images/integralCenter/wsxx.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      this.changeStatus();
      this.prefixQue();
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      this.changeStatus();
      setTimeout(() => {
        this.queryList();
      }, 1000);
    },
    //活动管理查询
    queryList() {
      this.talbeLoading = true;
      if (this.actManag == true) {
        this.recordData.mainType = 2;
      } else {
        this.recordData.mainType = 1;
      }

      this.activityList.forEach((item, index) => {
        var ref = "qrcode" + item.id;
        // console.log( this.$refs[ref])
        this.$refs[ref].innerHTML = "";
      });
       this.talbeLoading = true;
        if (this.opentime==true) {
      //  this.recordData.startTime = this.mytimestart;
      // this.recordData.endTime = this.mytimeend;
        this.opentime=false;
      }
      console.log(this.recordData, 12212);
      queryActivity(this.recordData)
        .then((res) => {
          this.talbeLoading = false;
          let mesUrl = "";
          this.activityList = res.data.records;
          this.totalNum = Number(res.data.total);
          this.activityList.forEach((item, index) => {
            if (item.activityType == 1) {
              mesUrl = "sign_polite"; //日历签到
            } else if (item.activityType == 2) {
              mesUrl = "sign_polite"; // 浏览礼品有礼
            } else if (item.activityType == 3) {
              mesUrl = "rob_goodPresent"; //每日抢好礼
            } else if (item.activityType == 4) {
              mesUrl = "attention_shop"; //关注店铺有礼
            } else if (item.activityType == 5) {
              mesUrl = "invitationopenCard"; //邀请开卡
            } else if (item.activityType == 6) {
              mesUrl = "invitationattention"; //邀请关注店铺
            } else if (item.activityType == 7) {
              mesUrl = "perfect_information"; //完善信息
            } else if (item.activityType == 8) {
              mesUrl = "lottery_turntable"; //大转盘抽奖
            }
            // console.log(this.activityUrl, 33333333);
            item.idUrl =
              this.activityUrl +
              "/point-h5/" +
              mesUrl +
              "?activityId=" +
              item.id +
              "&venderId=" +
              this.venderId;
            this.$nextTick(() => {
              let queryId = "qrcode" + item.id;
              this.qrcodeAll(item.idUrl, queryId);
            });
          });
        })
        .catch(() => {});
    },
    //大转盘管理查询

    // 表单查询
    searchForm(form) {
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.activityType = form.activityType;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      console.log('form:',  this.recordData);
      this.queryList();
    },

    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.queryList();
    },

    //结束活动
    endenActivity(id) {
      // console.log(123);
      this.outerVisible = true;
      this.ids = id;
    },

    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    //修改

    modify(row, val) {
      console.log(val);
      if (row == 8) {
        this.createStep = 4;
        this.stepNum = 1;
        this.ids = val.id;
        console.log(this.ids, "详情2");
      } else {
        this.createStep = 2;
        this.createActivity(row);
        this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
        console.log(val, "val");
      }
      this.$emit("changeData");
    },
    changeStatus() {
      this.$emit("changeStatus");
    },
    //数据统计
    statisData(row) {
      this.rowData = row;
      console.log(row);
      this.ids1 = row.id;
      this.createStep = 3;
    },
  },
};
</script>

<style lang="scss" scoped>
.activityManage {
  box-sizing: border-box;
  padding: 20px 28px 30px;

  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .y1,
  .y2,
  .y3 {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .y1 {
    background-color: #cccccc;
  }
  .y2 {
    background-color: #7f85e9;
  }
  .y3 {
    background-color: #fe4d45;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    span {
      flex: 1;
      cursor: pointer;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
</style>
